import ActionTypes from "../constants";
import * as api from '../api/index';
// import Swal from 'sweetalert2';
// import Router from "next/router";
import Toast from "../components/Toast"

export const getAllJobCard = (page, currentRowsPerPage, filter) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.INDEXLOADING,
        payload: true,
    });
    const response = await api.getAllJobCard(page, currentRowsPerPage, filter).then(res => {

        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETJOBCARDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.INDEXLOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.INDEXLOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETJOBCARDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.GETJOBCARDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getAllJobCards = (page, currentRowsPerPage, filter) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.INDEXLOADING,
        payload: true,
    });
    const response = await api.getAllJobCard(page, currentRowsPerPage, filter).then(res => {

        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETALLJOBCARDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.INDEXLOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.INDEXLOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETALLJOBCARDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.GETALLJOBCARDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getAllParallelJobCard = (page, currentRowsPerPage, parallelFilter) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.getAllParallelJobCard(page, currentRowsPerPage, parallelFilter).then(res => {

        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETPARALLELJOBCARDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETPARALLELJOBCARDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.GETPARALLELJOBCARDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getJobCardById = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.ADDEDITLOADING,
        payload: true,
    });
    const response = await api.getJobCardById(id).then(res => {

        if (JSON.parse(res).status == 200) {

            dispatch({
                type: ActionTypes.GETJOBCARDBYIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.ADDEDITLOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.ADDEDITLOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETJOBCARDBYIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.GETJOBCARDBYIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getSaleOrderByInsuranceId = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getSaleOrderByInsuranceId(id).then(res => {

        if (JSON.parse(res).status == 200) {

            dispatch({
                type: ActionTypes.GETJOBCARDBYINSURANCEIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETJOBCARDBYINSURANCEIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.GETJOBCARDBYINSURANCEIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getSaleOrderByCustomerId = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getSaleOrderByCustomerId(id).then(res => {

        if (JSON.parse(res).status == 200) {

            dispatch({
                type: ActionTypes.GETJOBCARDBYCUSTOMERIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETJOBCARDBYCUSTOMERIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.GETJOBCARDBYCUSTOMERIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}


export const getJobCardByEstimateId = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.ADDEDITLOADING,
    //     payload: true,
    // });
    const response = await api.getJobCardByEstimateId(id).then(res => {
        if (JSON.parse(res).status == 200) {

            dispatch({
                type: ActionTypes.GETJOBCARDBYESTIMATEIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            // dispatch({
            //     type: ActionTypes.ADDEDITLOADING,
            //     payload: false,
            // });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.ADDEDITLOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETJOBCARDBYESTIMATEIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.GETJOBCARDBYESTIMATEIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getJobCardByInsuranceCompanyId = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.getJobCardByInsuranceCompanyId(id).then(res => {

        if (JSON.parse(res).status == 200) {

            dispatch({
                type: ActionTypes.GETJOBCARDBYINSURANCECOMPANYIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETJOBCARDBYINSURANCECOMPANYIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.GETJOBCARDBYINSURANCECOMPANYIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getJobLatestId = () => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.getJobLatestId().then(res => {

        if (JSON.parse(res).status == 200) {

            dispatch({
                type: ActionTypes.GETJOBCARDIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETJOBCARDIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.GETJOBCARDIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const saveJobCard = (data, navigate) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.saveJobCard(data).then(res => {
        // 
        // 'job card saved');
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.SAVEJOBCARDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Saved Successfully!'
            });
            // navigate('/jobCard');
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SAVEJOBCARDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.SAVEJOBCARDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const generatePurchaseOrders = (data) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.generatePurchaseOrders(data).then(res => {
        // 
        // 'job card saved');
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.SAVEJOBCARDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Saved Successfully!'
            });
            // navigate('/jobCard');
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SAVEJOBCARDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.SAVEJOBCARDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const savePerformaInvoice = (data, navigate) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.savePerformaInvoice(data).then(res => {

        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.SAVEPERFORMAINVOICESUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Invoice Saved Successfully!'
            });
            window.open(JSON.parse(res).data, '_blank');
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SAVEPERFORMAINVOICEFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.SAVEPERFORMAINVOICEFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const updateJobCard = (data, id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.updateJobCard(data, id).then(res => {

        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.UPDATEJOBCARDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.UPDATEJOBCARDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.UPDATEJOBCARDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const toggleJobCard = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.toggleJobCard(id).then(res => {

        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.TOGGLEJOBCARDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Status Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.TOGGLEJOBCARDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        dispatch({
            type: ActionTypes.TOGGLEJOBCARDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}
export const bulkJobOut = (data, navigate) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.bulkJobOut(data).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.SAVEJOBCARDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Saved Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SAVEJOBCARDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {

        dispatch({
            type: ActionTypes.SAVEJOBCARDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}


